import { useState, memo } from 'react';
import { AttributeRenderer } from './AttributeRenderer';

export const AttributeGroup = memo(function AttributeGroup({
  groupId, label, icon, attributes, visibleAttributeIds, editableAttributeIds,
  values, errors, requiredOverrides, unrequiredOverrides,
  onFieldChange, collapsible = true, defaultCollapsed = false,
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const visible = attributes.filter(a => visibleAttributeIds.has(a.id));
  if (visible.length === 0) return null;
  const errCount = attributes.filter(a => errors[a.id]).length;

  return (
    <div className={`ag${collapsed ? ' ag-collapsed' : ''}`} id={`group-${groupId}`}>
      <button type="button" className="ag-hdr"
        onClick={() => collapsible && setCollapsed(c => !c)}
        aria-expanded={!collapsed} aria-controls={`agb-${groupId}`}>
        <span className="ag-title">
          {icon && <span aria-hidden="true">{icon} </span>}
          {label}
        </span>
        <span className="ag-meta">
          {errCount > 0 && <span className="ag-err-badge">{errCount}</span>}
          <span className="ag-count">{visible.length} fields</span>
          {collapsible && <span aria-hidden="true" className="ag-chev">{collapsed ? '▶' : '▼'}</span>}
        </span>
      </button>
      {!collapsed && (
        <div id={`agb-${groupId}`} className="ag-body">
          {visible.map(attr => {
            const req =
              (!!attr.validation?.required || requiredOverrides.has(attr.id)) &&
              !unrequiredOverrides.has(attr.id);
            return (
              <AttributeRenderer
                key={attr.id}
                attribute={attr}
                value={values[attr.id] ?? attr.defaultValue}
                error={errors[attr.id]}
                isRequired={req}
                isEditable={editableAttributeIds.has(attr.id)}
                onChange={val => onFieldChange(attr.id, val)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
});
